import Instruction from '@flatsy/core/Content/Instruction'
import Separator from '@flatsy/core/Layout/Separator'
import { FrontApplicationBookingState } from '@flatsy/types/Applications/BookingStatus'
import { FrontApplicationState } from '@flatsy/types/Applications/Status'
import Carousel from '@flatsy/utils/Functions/Carousel'
import React from 'react'
import Address from 'src/containers/Application/Booking/Overview/Address'
import Agent from 'src/containers/Application/Booking/Overview/Agent'
import DateStatus from 'src/containers/Application/Booking/Overview/DateStatus'
import Information from 'src/containers/Application/Booking/Overview/Information'
import Waiting from 'src/containers/Application/Booking/Overview/Waiting'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { renderVerlingue } from 'src/utils/Verlingue'
import { useStyles } from './Style'
import UpdateBookingInformation from './UpdateBookingInformation'

const BookingOverview: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const {
    asset,
    application: { application },
  } = useApplicationDetails()

  const renderBookingDetails = () => {
    if (application.computedState !== FrontApplicationState.WAITING_LIST) {
      return (
        <div className={classes.containerCards}>
          <div
            className={
              application.computedBookingState === FrontApplicationBookingState.CANCELLED ||
              application.computedBookingState === FrontApplicationBookingState.RESCHEDULED
                ? classes.containerCardLarge
                : classes.containerCard
            }
          >
            <DateStatus application={application} />
            <Agent application={application} asset={asset} />
          </div>
          <Address application={application} />
          <UpdateBookingInformation application={application} />
          {renderVerlingue(application?.is_verlingue_supported)}
        </div>
      )
    }

    return <Waiting asset={asset} />
  }

  const renderIsInstructions = () => {
    return (
      asset?.instructions && (
        <>
          <Instruction asset={asset} />
          <Separator size="16px" />
        </>
      )
    )
  }

  const renderIsImg = () => {
    return (
      asset?.img_urls &&
      asset?.img_urls.length !== 0 && (
        <>
          <Carousel asset={asset} size="large" />
          <Separator size="16px" />
        </>
      )
    )
  }

  return (
    <div className={classes.container}>
      {renderBookingDetails()}
      <div className={classes.sidebar}>
        {renderIsInstructions()}
        {renderIsImg()}
        <Information asset={asset} />
      </div>
    </div>
  )
}

export default BookingOverview
